import { Alert } from 'antd';
import React from 'react';
import styled from 'styled-components';
import useListDomains from '../../useListDomains';
import DomainNode from './DomainNode';
import { Domain } from '../../../../types.generated';

const NavigatorWrapper = styled.div`
    overflow: auto;
    font-size: 14px;
    padding: 8px 8px 16px 16px;
    background-color: #ffffff;
    max-height: calc(100% - 53px);
`;

interface Props {
    showIcon?: boolean;
    domainUrnToHide?: string;
    isDomainAccessible?: boolean;
    selectDomainOverride?: (domain: Domain) => void;
}

export default function DomainNavigator({
    domainUrnToHide,
    selectDomainOverride,
    isDomainAccessible,
    showIcon,
}: Props) {
    const { sortedDomains, error } = useListDomains({});

    return (
        <NavigatorWrapper className="f-domain-navigator">
            {error && <Alert message="Loading Domains failed." showIcon type="error" />}
            {sortedDomains?.map((domain) => (
                <DomainNode
                    key={domain.urn}
                    domain={domain as Domain}
                    numDomainChildren={domain.children?.total || 0}
                    domainUrnToHide={domainUrnToHide}
                    selectDomainOverride={selectDomainOverride}
                    showIcon={showIcon}
                    isDomainAccessible={isDomainAccessible}
                />
            ))}
        </NavigatorWrapper>
    );
}
